




import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GExamCreateConfirmViewItemCell',
  computed: {},
  methods: {},
})
export default class GExamCreateItemCell extends Vue {
  mounted() {}
}
